/* eslint-disable max-len */

const StringConstantsMixin = {
  strings: {
    // utility to translate words in minfied JS
    START_TRANSLATE: 'START_TRANSLATE',
    CLOSE: 'Close',
    EXPAND_MAP: 'Expand map',
    SUCCESS: 'Success',
    TRAIL: 'Trail',
    TRAILS: 'Trails',
    NEAR: 'near',
    THAT_MATCH: 'that match',
    SENT: 'Sent',
    ICON: 'Icon',
    SEARCH_WORD: 'Search',
    REQUIRED: 'Required',
    LIST_COPY: 'Copy to my Lists',
    LIST_COPY_IN_PROGRESS: 'Copying...',
    LIST_COPY_SUCCESS: 'Successfully Copied',
    CLEAR_FILTERS: 'Clear filters',
    NO_RESULTS: 'No results',
    NO_MAPS: 'No Maps.',
    MAP_OPTIONS: 'Map options',
    MAP_TYPES: 'Map types',
    MAP_DETAILS: 'Map details',
    DIRECTIONS: 'Directions',
    PRINT_MAP: 'Print map',
    PDF_MAP: 'PDF Map',
    TERRAIN_AVAILABLE: '3D available',
    START: 'start',
    END: 'end',
    USER_AVATAR_ALT: `View user's profile page`,
    NO_RECORDINGS: 'No Activities.',
    NO_TRAILS_IN_LIST: 'No trails in list.',
    TOTAL: 'Total',
    DELETE_LIST_QUESTION: 'Are you sure you want to delete this list?',
    DELETE_ITEM_QUESTION: 'Are you sure you want to delete this from AllTrails?',
    TRAILS_NEAR: 'Trails near: ',
    MY_MAPS: 'My Maps',
    MY_MAP: 'My Map',
    MAP: 'Map',
    RECORDING: 'Activity',
    STATUS: 'Status',
    MY_RECORDINGS: 'My Activities',
    MY_ACCOUNT: 'My Account',
    MORE_TRAILS: 'More Trails',
    VIEW_TRAIL_DETAILS: 'View Trail Details',
    VIEW_LIST_DETAILS: 'View List Details',
    VIEW_FULL_MAP: 'View Full Map',
    EXPLORE_TRAILS: 'Explore Trails',
    PHOTOS: 'photos',
    PHOTO: 'Photo',
    WAYPOINT: 'Waypoint',
    DRAG_TO_DESIRED_LOCATION: 'Drag to desired location',
    LOCATION: 'Location',
    LISTS: 'Lists',
    LIST: 'List',
    NEW_WAYPOINT: 'New Waypoint',
    EDIT_WAYPOINT: 'Edit Waypoint',
    ADD_NEW_WAYPOINT: 'Add new waypoint',
    PRIVATE_LIST: 'Private List',
    PUBLIC_LIST: 'Public List',
    PRIVATE_UPPER_CASE: 'PRIVATE',
    TITLE: 'Title',
    SHARE_YOUR_ROUTE: 'Share your route with others',
    RECORDINGS_HELP_OTHERS: 'Help other users find their next route. Upload your activity and inspire others.',
    ADD_YOUR_PHOTOS: 'Add photos of this trail',
    PHOTOS_HELP_OTHERS: 'Photos help others preview the trail. Upload photos about this trail to inspire others.',
    JOIN_THE_LIST: 'Join the list',
    USE_RECORDER_ZERO: 'Use Navigator in the AllTrails app and be the first outdoor explorer who has completed this trail.',
    USE_RECORDER_SINGULAR: 'Use Navigator in the AllTrails app and join the other outdoor explorer who has completed this trail.',
    USE_RECORDER_PLURAL: 'Use Navigator in the AllTrails app and join the {completedCount} other outdoor explorers who have completed this trail.',
    VIEW_USERS_RECORDING: "View {userName}'s activity",
    REVIEW_SINGULAR: '1 Review',
    REVIEWS_PLURAL: '{count} Reviews',
    FIRST_TO_REVIEW: 'First to Review',
    NOTES: 'Notes',
    CAPTION: 'Caption',
    OR: 'or',
    BACK: 'Back',
    CLEAR: 'Clear',
    CANCEL: 'Cancel',
    CANCEL_EDIT: 'Cancel Edit',
    SUBMIT: 'Submit',
    MERGE: 'Merge',
    MOVE: 'Move',
    SAVE: 'Save',
    SAVED: 'Saved',
    SAVING: 'Saving...',
    UPLOAD: 'Upload',
    SMOOTH_FILE: 'Smooth file',
    EDIT: 'Edit',
    EDIT_DESCRIPTION: 'Edit Description',
    EDIT_SEO_DESCRIPTION: 'Edit SEO Description (web-only, HTML required)',
    EDIT_TRAIL_ALERTS: 'Edit Trail Alerts',
    COMMENT: 'Comment',
    REMOVE: 'Remove',
    DONE: 'Done',
    DELETE: 'Delete',
    FAILED: 'Failed',
    HELP: 'Help',
    ERROR_OCCURRED: 'Error occurred',
    ERR_TRY_AGAIN: 'Error, please try again',
    MAPBOXGL_NOT_SUPPORTED:
      'It appears that your browser does not support MapboxGL, a library that is required to render maps on AllTrails.com. Please upgrade or change browsers before reloading the page. See https://docs.mapbox.com/help/troubleshooting/mapbox-browser-support/ for more details. Contact customer support with details about your device and browser if issue persists.',
    ADD: 'Add',
    MORE: 'More',
    SHARE: 'Share',
    SHARE_MAP: 'Share map',
    SHOW_MORE: 'Show more',
    SHOW_LESS: 'Show less',
    REORDER: 'Reorder',
    SUGGEST: 'Suggest',
    LATITUDE: 'Latitude',
    LONGITUDE: 'Longitude',
    FAVORITE: 'Favorite',
    FAVORITED: 'Favorited',
    SAVE_FAVORITE: 'Save to your favorites',
    SAVE_CHANGES: 'Save Changes',
    MORE_MAPS: 'More Maps',
    MORE_RECORDINGS: 'More Activities',
    ALL_PHOTOS: 'All Photos',
    MORE_OPTIONS: 'More options',
    THANK_YOU: 'Thank you',
    SUGGEST_EDIT: 'Suggest Edit',
    SET_AS_ROUTE: 'Set as Route',
    SUGGEST_AS_ROUTE: 'Suggest as Route',
    SUGGEST_AS_ROUTE_LOWER: 'Suggest as route',
    CREATE_LIST: 'Create new list',
    CREATE: 'Create',
    SETTING: 'Setting...',
    DELETING: 'Deleting...',
    REMOVING: 'Removing...',
    SUGGESTING: 'Suggesting...',
    DELETED: 'Deleted',
    REMOVED: 'Removed',
    SET: 'Set',
    RECORDED: 'recorded',
    ROUTE_SET: 'Route set',
    FAILED_RETRY: 'Failed, retry?',
    SEE_ALL: 'See All',
    TOP: 'Top',
    RATING: 'Rating',
    PRIVATE: 'Private',
    REVIEW: 'Review',
    ACTIVITY: 'Activity Type',
    TYPE: 'Type',
    ACTIVITY_DATE: 'Activity Date',
    ON: 'on',
    REVIEWED: 'reviewed',
    SHOW_ORIGINAL: 'Show Original',
    SHOW_TRANSLATION: 'Show Translation',
    SAVE_TO: 'Save to',
    APPLY: 'Apply',
    RESET: 'Reset',
    SEE_RESULTS: 'See results ({resultsCount})',
    FILTER: 'Filter',
    SUNSET: 'Sunset',
    SUNRISE: 'Sunrise',
    UPLOADING: 'Uploading',
    UPDATE: 'Update',
    SEE_TRANSLATION: 'See translation',
    SEE_ORIGINAL: 'See original',
    X_MAP: '{x} Map',
    ABBREVIATIONS: {
      MILES: 'mi',
      FEET: 'ft',
      KILOMETERS: 'km',
      METERS: 'm'
    },
    SOMETHING_WENT_WRONG: 'Something went wrong',
    CLICK_RETRY: 'Click the button below to try again',
    FACEBOOK: {
      FACEBOOK_SETTINGS: 'Facebook settings',
      LOGIN_FACEBOOK: 'Log in with Facebook',
      SYNC: 'Sync Facebook friends',
      REFRESH_FRIENDS: 'Refresh Facebook friends'
    },
    PRIVACY_POLICY: {
      CONTENT: 'Content',
      PRIVACY_SETTINGS: 'Privacy settings',
      YOUR_NAME_YOUR_PROFILE_HOMETOWN: 'Your name, profile picture, and hometown may be seen by anyone who views your profile.',
      YOUR_CONTENT_DISPLAYED_WHEN_SOMEONE_ELSE:
        'Your content is displayed when someone views your profile. Choose your default level of privacy for each type of newly-created content. Changes made now will not affect the privacy levels of existing content.',
      YOUR_CONTENT_IS_VIEWED:
        'Your content is displayed when someone views your profile. Choose your default level of privacy for each type of content.',
      YOUR_CONTENT_TWO_PLACES:
        'Your content displays in two places: on your profile and in your followers’ feeds. Choose your default level of privacy for each type of content.',
      REVIEWS_AND_UPLOADED_SHARED:
        'Reviews and uploaded trail photos are shared with the AllTrails community to help others know what to expect out on the trail.',
      PUBLIC: 'Public',
      FOLLOWERS_ONLY: 'Followers only',
      ONLY_ME: 'Only me',
      YES: 'Yes',
      NO: 'No',
      MAP_PRIVACY: 'Map privacy',
      ACTIVITY_PRIVACY: 'Activity privacy',
      REQUIRE_FOLLOWER_REQUESTS: 'Require follower requests',
      ACTIVITIES_LABEL: 'Activities',
      YOUR_COMMUNITY: 'Your community',
      COMPLETED_TRAILS_LABEL: 'Completed trails',
      YOUR_COMMUNITY_INCLUDES: 'Your community includes who you follow and who follows you.',
      DO_NOT_REQUIRE_FOLLOWER_REQUESTS: 'Do not require follower requests.',
      REQUIRE_FOLLOW_REQUESTS: 'Require follower requests.',
      YOUR_COMMUNITY_IS_VISIBLE_ANYONE: 'Your community is visible to anyone.',
      YOUR_COMMUNITY_IS_VISIBLE_FOLLOWERS: 'Your community is only visible to your followers.',
      YOUR_COMMUNITY_VISIBLE_YOU: 'Your community is only visible to you.',
      YOUR_COMPLETED_TRAILS_DO_NOT_INCLUDE:
        'Your completed trails do not include the date or time the trail was completed, just that you’ve completed it.',
      YOUR_COMPLETED_TRAILS_VISIBLE_ANYONE: 'Your completed trails are visible to anyone.',
      YOUR_COMPLETED_TRAILS_VISIBLE_FOLLOWERS: 'Your completed trails are only visible to your followers.',
      YOUR_COMPLETED_TRAILS_VISIBLE_YOU: 'Your completed trails are only visible to you.',
      ANYTIME_YOU_USE_NAVIGATOR:
        'Anytime you use Navigator on the trail, you create an activity to save in your history. Each activity includes a date and time, along with your route and stats.',
      NOTE_PRIVACY_LEVEL_ACTIVITY: 'Note: You can always change the privacy level for any individual activity.',
      YOUR_ACTIVITIES_VISIBLE_ANYONE: 'Your activities are visible by anyone.',
      YOUR_ACTIVITIES_VISIBLE_FOLLOWERS: 'Your activities are only visible to your followers.',
      YOUR_ACTIVITIES_VISIBLE_YOU: 'Your activities are only visible to you.',
      THIS_INCLUDES_MAPS_CREATED_DOWNLOADED: 'This includes maps you’ve created or downloaded, along with those tied to an activity.',
      NOTE_PRIVACY_LEVEL_MAPS: 'Note: You can always change the privacy level for any individual map.',
      YOUR_MAPS_VISIBLE_ANYONE: 'Your maps are visible by anyone.',
      YOUR_MAPS_VISIBLE_FOLLOWERS: 'Your maps are only visible to your followers.',
      YOUR_MAPS_VISIBLE_YOU: 'Your maps are only visible to you.',
      THE_LISTS_YOU_CREATE: 'The lists you create can include activities, trails, and maps you’ve favorited.',
      YOU_CAN_ALWAYS_CHANGE_THE_PRIVACY: 'Note: You can always change the privacy level for any individual list.',
      YOUR_LISTS_VISIBLE_ANYONE: 'Your lists are visible by anyone.',
      YOUR_LISTS_VISIBLE_FOLLOWERS: 'Your lists are only visible to your followers.',
      YOUR_LISTS_VISIBLE_YOU: 'Your lists are only visible to you.',
      CHOOSE_WHO_CAN_VIEW_THIS_MAP: 'Choose who can view this map.',
      THIS_MAP_VISIBLE_ANYONE: 'This map is visible by anyone.',
      THIS_MAP_VISIBLE_FOLLOWERS: 'This map is only visible to your followers.',
      THIS_MAP_VISIBLE_YOU: 'This map is only visible to you.',
      CHOOSE_WHO_CAN_VIEW_THIS_ACTIVITY: 'Choose who can view this activity.',
      THIS_ACTIVITY_VISIBLE_ANYONE: 'This activity is visible by anyone.',
      THIS_ACTIVITY_VISIBLE_FOLLOWERS: 'This activity is only visible to your followers.',
      THIS_ACTIVITY_VISIBLE_YOU: 'This activity is only visible to you.',
      CHOOSE_WHO_CAN_VIEW_THIS_LIST: 'Choose who can view this list',
      THIS_LIST_VISIBLE_ANYONE: 'This list is visible by anyone.',
      THIS_LIST_VISIBLE_FOLLOWERS: 'This list is only visible to your followers.',
      THIS_LIST_VISIBLE_YOU: 'This list is only visible to you.',
      LIST_PRIVACY: 'List privacy',
      APPLY_TO_PAST_CONTENT: 'Apply to past content'
    },
    TIME: {
      MULTI_DAY: 'Multi-day'
    },
    ALT_TEXT: {
      CARET: 'Caret',
      YELLOW_STAR: 'Yellow Star',
      GRAY_STAR: 'Gray Star'
    },
    TRAIL_FORM_SUCCESS: {
      THANKS_FOR_REVIEW: 'Thanks for your review',
      COMMUNITY_RELIES: 'The community relies on great reviews like yours.',
      PHOTOS_UPLOADED: 'Photos uploaded',
      YOURE_HELPING: 'You’re helping the community preview trails.',
      KEEP_SNAPPING_SHARING: 'Keep snapping and sharing!',
      KEEP_EM_COMING: 'Keep ’em coming!',
      RECORDING_UPLOADED: 'Activity uploaded',
      FIND_NEW_ROUTES: "You're helping the community find new routes.",
      KEEP_EXPLORING: 'Keep exploring!',
      ROUTE_UPLOADED: 'Route uploaded',
      ROUTE_ADDED: 'Route has been added to your map.',
      KEEP_CREATING: 'Keep creating!'
    },
    SEARCH: {
      MAX_NUM_RESULTS: '1000+',
      SEARCH_FAVORITE_TRAILS: 'Search favorite trails...',
      SEARCH_COMPLETED_TRAILS: 'Search completed trails...',
      SEARCH_FOR_TRAILS: 'Searching for trails...',
      SHOWING_TRAIL_OF: 'Showing {amount} of {total} trails',
      SHOWING_TRAIL_OF_1: 'Showing {amount} of {total} trail',
      SHOWING_ITEM_OF: 'Showing {amount} of {total} items',
      SHOWING_ITEM_OF_1: 'Showing {amount} of {total} item',
      SHOWING_RECORDING_OF: 'Showing {amount} of {total} activities',
      SHOWING_RECORDING_OF_1: 'Showing {amount} of {total} activities',
      SHOWING_MAP_OF: 'Showing {amount} of {total} maps',
      SHOWING_MAP_OF_1: 'Showing {amount} of {total} map',
      SHOWING_PARK_OF_IN: '#{amount} of {total} {parks} in {location}',
      SHOWING_AMOUNT_OF_TOTAL: 'Showing results {min} - {max} of {total}',
      SHOW_MORE_TRAILS: 'Show more trails',
      SHOW_MORE_PHOTOS: 'Show more photos',
      SHOW_MORE_REVIEWS: 'Show more reviews',
      SHOW_MORE_TRACKS: 'Show more activities',
      SHOW_MORE_COMPLETED: 'Show more completed',
      MAP_OF_TRAILS_IN: 'Map of trails in',
      MAP_OF_TRAILS_NEAR: 'Map of trails near',
      CURRENT_LOCATION: 'Current Location',
      NO_ONE_REVIEWED: 'No one has reviewed this trail yet. Be the first!',
      NO_ONE_PHOTOS: 'No one has added photos of this trail yet. Be the first!',
      NO_ONE_RECORDED: 'There are no activities for this trail yet. Create the first!',
      NO_ONE_COMPLETED: 'No one has completed this trail yet. Be the first!',
      ZOOM_IN: 'Zoom Map In',
      ZOOM_OUT: 'Zoom Map Out',
      RESET_NORTH_PITCH: 'Reset North and Pitch',
      ENABLE_3D: 'Enable 3D Map',
      DISABLE_3D: 'Disable 3D Map',
      DID_YOU_MEAN: 'Did you mean...',
      SORRY_CANT_FIND: "Sorry we can't find",
      DONT_SEE: "Don't see what you're looking for?",
      CONTACT_US: 'Contact us.',
      PLEASE_TRY_AGAIN: 'Please try again',
      LOADING: 'Loading...',
      LOADING_NO_ELLIPSIS: 'Loading',
      LOAD_MORE: 'Load More',
      LOAD_MORE_TRAILS: 'Load More Trails',
      SEARCH_LIST: 'Search list...',
      SEARCH_RECORDINGS: 'Search activities...',
      SEARCH_MAPS: 'Search Maps...',
      TRAIL_LOAD: 'Hang in there while we search through 200,000+ trails to find the ones for you.',
      RECORDING_LOAD: 'Hang in there while we load your activities.',
      MAP_LOAD: 'Hang in there while we load your maps.',
      MAP_LOAD_INFO: 'Loading Map Info...',
      TRAIL_LOAD_INFO: 'Loading Trail Info...',
      RECORDING_LOAD_INFO: 'Loading activity Info...',
      MAP_LOAD_YOUR: 'Loading your maps...',
      RECORDING_LOAD_YOUR: 'Loading your activities...',
      ADD_TO_FAVORITES: 'Add To Favorites',
      REMOVE_FROM_FAVORITES: 'Remove From Favorites',
      ADD_TO_COMPLETED: 'Add To Completed',
      REMOVE_FROM_COMPLETED: 'Remove From Completed',
      ADD_TO_LIST: 'Add To List',
      REMOVE_FROM_LIST: 'Remove From List',
      MAP_LOAD_MSG: 'Hang in there while we load more details about the map',
      TRAIL_LOAD_MSG: 'Hang in there while we load more details about the trail',
      RECORDING_LOAD_MSG: 'Hang in there while we load more details about the activity',
      SORTING_LOAD_MSG: 'Hang in there while we sort through all these',
      CLEAR_FILTERS_MORE_RESULTS: 'Clear your current search filters to see more results.',
      CLEAR_FILTERS_ALL_TRAILS: 'Clear your current search filters to see all trails.',
      CLEAR_FILTERS_ALL_MAPS: 'Clear your current search filters to see all maps.',
      CLEAR_FILTERS_ALL_RECORDINGS: 'Clear your current search filters to see all activities.',
      FAVORITE_PROMPT: 'Tap the save icon on any trail to add it to this list.',
      COMPLETION_PROMPT: 'Add to this list from the Completed tab of any trail. Or download the AllTrails app to save new travels with Navigator.',
      RECORDER_PROMPT: 'Save activities by navigating your route in the AllTrails app. On desktop, upload activities from Garmin, Google, and more.',
      LIST_PROMPT: 'Search for trails to add to this list.',
      PLAN_PROMPT: 'Create a custom map using the AllTrails map creation tool',
      FIND_LOCATION: 'Find Location',
      ENTER_CITY_PARK_OR_LAT_LNG: 'Enter a city, park, or lat,long...',
      ENTER_CITY_PARK_OR_TRAIL_NAME: 'Enter a city, park or trail name',
      ENTER_MEMBERS_NAME: "Enter a member's name...",
      HIDE_NEARBY_TRAILS: 'Hide Nearby Trails',
      SHOW_NEARBY_TRAILS: 'Show Nearby Trails',
      CREATE_NEW_MAP: 'Create map',
      COMMUNITY_CONTENT: 'Community Content',
      CURATED_TRAILS: 'Curated Trails',
      NO_RESULTS_FOUND: 'No Results Found',
      ENTER_AN_ADDRESS_CITY_PARK: 'Enter an address, city, park, or lat, long…',
      SEARCH_DEFAULT_PLACEHOLDER: 'Search by city, park, or trail name',
      WE_COULDNT_FIND: 'We couldn’t find anything matching',
      SEARCH_NEARBY: 'Search nearby',
      NO_RESULTS: {
        CURATED_TRAILS: {
          BUTTON: 'View community content',
          TITLE: {
            LONG: 'No results found',
            SHORT: 'Looking for more?'
          },
          BODY: {
            LONG: `Let's get you back on track! Zoom out or try the "Community Content" tab to see if others have explored here.`,
            SHORT: `Adjust your filters or zoom out. You can also try the "Community Content" tab to see if others have explored here.`
          }
        },
        CURATED_TRAILS_OVER_FILTERED: {
          BUTTON: 'Clear filters',
          TITLE: {
            LONG: 'No results found',
            SHORT: 'Looking for more?'
          },
          BODY: {
            LONG: `Let's get you back on track! Adjust your filters or zoom out. You can also try the "Community Content" tab to see if others have explored here.`,
            SHORT: `Adjust your filters or zoom out. You can also try the "Community Content" tab to see if others have explored here.`
          }
        },
        COMMUNITY_CONTENT: {
          BUTTON: 'View curated trails',
          TITLE: {
            LONG: 'No results found',
            SHORT: 'Looking for more?'
          },
          BODY: {
            LONG: `Let's get you back on track! Zoom out or try the "Curated Trails" tab to see if others have explored here.`,
            SHORT: `Adjust your filters or zoom out. You can also try the "Curated Trails" tab to see trails in this area.`
          }
        },
        COMMUNITY_CONTENT_OVER_FILTERED: {
          BUTTON: 'Clear filters',
          TITLE: {
            LONG: 'No results found',
            SHORT: 'Looking for more?'
          },
          BODY: {
            LONG: `Let's get you back on track! Adjust your filters or zoom out. You can also try the "Curated Trails" tab to see if others have explored here.`,
            SHORT: `Adjust your filters or zoom out. You can also try the "Curated Trails" tab to see trails in this area.`
          }
        }
      }
    },
    BREADCRUMB_ITEMS: {
      MEMBERS: 'Members',
      MAPS: 'Maps',
      RECORDINGS: 'Activities',
      LIFELINE: 'Lifeline'
    },
    LOCATIONS: {
      CITY: 'City',
      REGION: 'Region'
    },
    MAP_LAYER_NAMES: {
      TERRAIN: 'Terrain',
      ROAD: 'Road',
      SATELLITE: 'Satellite',
      WORLD_PARKS: 'World parks',
      USGS_TOPO_US_ONLY: 'USGS Topo (US only)'
    },
    MONTHS: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    DAYS_OF_WEEK: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
    // maintain case of NON_HOUR_TIMES keys for api updates
    NON_HOUR_TIMES: {
      ALL_DAY: 'all day',
      CLOSED: 'closed',
      DAWN: 'dawn',
      DUSK: 'dusk'
    },
    TAB_NAMES: {
      DESCRIPTION: 'Description',
      OVERVIEW: 'Overview',
      WAYPOINTS: 'Waypoints',
      WEATHER: 'Weather',
      TIPS: 'Tips',
      GETTING_THERE: 'Getting There',
      FACILITIES: 'Facilities',
      CONTACT: 'Contact',
      PARK_INFO: 'Park Info',
      REVIEWS: 'Reviews',
      PHOTOS: 'Photos',
      RECORDINGS: 'Activities',
      COMPLETED: 'Completed'
    },
    SEARCH_TAB_NAMES: {
      ALL: 'all',
      PLACES: 'places',
      PARKS: 'parks',
      TRAILS: 'trails',
      MAPS: 'maps',
      RECORDINGS: 'activities',
      LISTS: 'lists'
    },
    PARK_INFO: {
      TITLE: 'Park information',
      WEBSITE: 'Website',
      PHONE_NUMBER: 'Phone number',
      HELPFUL_LINKS: 'Helpful links',
      PARK_HOURS: 'Park hours',
      NATIONAL_PARKS: 'national parks',
      STATE_PARKS: 'state parks',
      LOCAL_PARKS: 'local parks',
      AREA: 'Area',
      ACREAGE: 'Acreage',
      ACRES: 'acres',
      HECTARES: 'hectares',
      MAILING_ADDRESS: 'Mailing address',
      All_DAY: 'All day',
      CLOSED: 'Closed',
      COPY_TO_ALL: 'Copy to all',
      CLEAR_ALL: 'Clear all',
      OF: 'of',
      IN: 'in',
      TOP_TRAILS: 'Top trails',
      TOP_NATIONAL_PARKS: 'Top national parks',
      TOP_STATE_PARKS: 'Top state parks'
    },
    ALERTS: {
      TYPE_LABEL: 'Alert Type',
      TYPES: {
        WARNING: 'Warning',
        INFORMATIONAL: 'Informational',
        CLOSURE: 'Closure'
      }
    },
    SORT: {
      atSort: 'AllTrails Sort',
      desc: 'Newest First',
      asc: 'Oldest First',
      highestRated: 'Highest Rated',
      lowestRated: 'Lowest Rated',
      SORT: 'Sort'
    },
    MAP_TIPS: {
      TERRAIN: {
        TITLE: '3D tip',
        TEXT: 'Tilt and rotate by holding "control" and dragging up, down, left, or right.',
        LEARN_MORE: 'Learn more'
      }
    },
    TRACK_DETAIL: {
      HIDE: 'Hide',
      UNHIDE: 'Unhide',
      NEW_MAP: 'New Map',
      CREATE_MAP: 'Create Map',
      ROUTE: 'Route',
      ROUTES: 'Routes',
      LINKED_TRAIL: 'Linked Trail:',
      DRAW_ROUTE: 'Draw route',
      FINISH_DRAWING_ROUTE: 'Please finish drawing route (or cancel) before attempting to save.',
      DIRECTIONS: 'Directions',
      RECORDING_TITLE: 'Name (Optional)',
      RECORDING_DESCRIPTION: 'Description (Optional)',
      PHOTO_UPLOAD_ROTATE_LABELS: {
        LEFT: 'Rotate left',
        RIGHT: 'Rotate right'
      },
      CANNOT_SAVE_UPDATE: 'Cannot save your update. Please try again.',
      DOWNLOAD_ROUTE: 'Download Route',
      DOWNLOAD_ROUTES: 'Download Routes',
      CHOOSE_FILE_FORMAT: 'Select a file format',
      UNDO: 'Undo',
      REDO: 'Redo',
      ACTIONS: {
        OUT_AND_BACK: 'Double-back',
        REVERSE: 'Reverse',
        RETURN: 'Close loop'
      },
      TOOLTIPS: {
        OUT_AND_BACK: 'Return back the same way',
        REVERSE: 'Switch your start and end points',
        RETURN: 'Return back the shortest way'
      },
      ROUTING: 'Routing',
      DRAWING: 'Drawing',
      ROUTE_MODES: {
        HIKING: 'Hiking',
        MOUNTAIN_BIKING: 'Mountain Biking',
        BIKE_TOURING: 'Bike Touring',
        ROAD_BIKING: 'Road Biking',
        OFF_ROAD_DRIVING: 'OHV/Off Road Driving',
        SCENIC_DRIVING: 'Scenic Driving'
      },
      ROUTING_TIPS: {
        SMART_ROUTING_LABEL: 'Smart Routing'
      }
    },
    REVIEW_UPLOAD_FORM: {
      NEXT: 'Next',
      POST: 'Post',
      stepText: (currentStep, finalStep) => `Step ${currentStep} of ${finalStep}`
    },
    PROFILE: {
      SET_NEW_PASSWORD: 'Set New Password',
      CALORIE_INFO: 'Calorie Counter Info',
      BIRTHDAY: 'Birthday',
      ABOUT_ME: 'About Me',
      UNITS: 'Units',
      RECORDING_PREFERENCE: 'Activity Time Preference',
      FAVORITE_ACTIVITIES: 'Favorite Activities',
      SPEED: 'Speed',
      PACE: 'Pace',
      LANGUAGE: 'Marketing Language',
      IMPERIAL: 'Imperial',
      METRIC: 'Metric',
      GENDER: 'Gender',
      MALE: 'male',
      FEMALE: 'female',
      HEIGHT: 'Height',
      WEIGHT: 'Weight',
      PRIVACY: 'Privacy',
      UNSPECIFIED: 'unspecified',
      MAKE_PROF_PRIVATE: 'Make my profile private',
      NO_LOCATION: 'No Current Location Info',
      MEMBER_LOCATION: 'Member location:',
      CHANGE_LOCATION: 'Change member location',
      IF_FOR_ORGANIZATION: 'Check here if this profile is for a company/organization',
      CHANGE_IMAGE: 'Change Image',
      ORGANIZATION_NAME: 'Organization Name'
    },
    STATS: {
      NORMAL: {
        AVG_SPEED: 'Avg Speed',
        AVG_PACE: 'Avg. pace',
        PACE: 'Pace',
        TOTAL_TIME: 'Total time',
        STATS: 'Stats',
        SPLITS: 'Splits',
        PERSONAL_BESTS: 'Personal Bests',
        DISTANCE: 'Distance',
        TOTAL_DISTANCE: 'Total Distance',
        LONGEST_DISTANCE: 'Longest Distance',
        MOVING_TIME: 'Moving time',
        ELEVATION_GAIN: 'Elevation gain',
        ELEV_GAIN: 'Elev Gain',
        COUNT: 'Count',
        CALORIES: 'Calories',
        CALORIES_BURNED: 'Calories Burned',
        LIFETIME_STATS: 'Lifetime Stats',
        ANNUAL_STATS: 'Annual Stats',
        RECORDED_IN: 'in',
        KILOMETERS: 'Kilometers',
        FEET: 'Feet',
        METERS: 'Meters',
        MILES: 'Miles',
        totalDistanceInYear: (distance, year) => `${distance} Total Distance in ${year}`,
        elevationGainInYear: (elevation, year) => `${elevation} Elevation Gain in ${year}`,
        movingTimeInYear: (time, year) => `${time} Moving Time in ${year}`,
        calorieInYear: (calories, year) => `${calories} Calorie in ${year}`,
        caloriesInYear: (calories, year) => `${calories} Calories in ${year}`,
        activityInYear: (numActivities, year) => `${numActivities} Activity in ${year}`,
        activitiesInYear: (numActivities, year) => `${numActivities} Activities in ${year}`
      },
      ABBR: {
        PER_MONTH: '/mo.'
      },
      LOWER: {
        CALORIES: 'calories',
        FEET: 'feet',
        HOURS: 'hours',
        KILOMETERS: 'kilometers',
        METERS: 'meters',
        MILES: 'miles',
        RECORDINGS: 'recordings'
      }
    },
    ELEV_CHART: {
      DISTANCE: 'Distance',
      ELEVATION: 'Elevation',
      GRADE: 'Grade',
      NO_DATA: 'No Elevation Data'
    },
    CONTRIBUTE: {
      UPLOAD_RECORDING: 'Upload activity',
      EDIT_ACTIVITY: 'Edit activity',
      UPLOAD_ROUTE: 'Upload route',
      OBSTACLES: 'Obstacles',
      SEASON: 'Season',
      ACCESSIBLE: 'Accessible',
      DOGS: 'Dogs',
      KIDS: 'Kids',
      ACTIVITIES: 'Activities',
      FEATURES: 'Features',
      USAGE: 'Usage',
      TRAILHEAD: 'Trailhead',
      DRAW_ROUTE: 'Draw Route',
      EDIT_ROUTE: 'Edit Route',
      UPLOAD_FILE: 'Upload file',
      BETTER_ROUTE: 'Suggest a better route',
      EDIT_TRAIL_INFO: 'Edit trail information',
      FIND_START_LOC: 'Find the starting location',
      CITY_OR_PARK: 'City or Park',
      SELECT_A_PARK: 'Select a park',
      ADD_TRAIL: 'add trail',
      ENTER_NEW_PARK_NAME: 'Enter new park name',
      DRAW_UPLOAD_RT: 'Draw/Upload the route',
      TRY_AGAIN: 'Try again',
      HERE: 'here',
      ROUTE_INSTRUCTIONS_W_GPX:
        "When adding new trails, we are specifically looking for trails that start and end at a parking area and are on public property. Our strong preference is for out-and-back or loop trails that begin and end in the same location, but of course some trails are through trails and they are welcome too. Please note that any suggested trail additions must first be evaluated by our moderators. This process may take a while depending on our ability to verify the information. To read more about how to draw a route click here.\n  If you have a recorded GPX file for the trail you can 'upload' that instead.",
      ROUTE_INSTRUCTIONS:
        'When adding new trails, we are specifically looking for trails that start and end at a parking area and are on public property. Our strong preference is for out-and-back or loop trails that begin and end in the same location, but of course some trails are through trails and they are welcome too. Please note that any suggested trail additions must first be evaluated by our moderators. This process may take a while depending on our ability to verify the information. To read more about how to draw a route click here.',
      STEPS: ['Step 1', 'Step 2', 'Step 3'],
      NEW: 'New',
      ADD_NEW_PARK: 'Add new park',
      NEW_PARK: 'New Park',
      IN_KILOMETERS: 'in kilometers',
      IN_MILES: 'in miles',
      COMMENT_FROM: 'Comment from {userFirstName}',
      DRAG_PHOTOS_HERE: {
        __html: 'Drag photos here or <span>browse</span>'
      },
      DRAG_RECORDING_HERE: {
        __html: 'Drag activity here or <span>browse</span>'
      },
      DRAG_ROUTE_HERE: {
        __html: 'Drag route here or <span>browse</span>'
      },
      PNG_JPG_JPEG: 'PNG, JPG or JPEG',
      GPX_TPO_FIT_TCX: 'GPX, TPO, FIT, TCX, KML, or KMZ',
      RETURN_TO_TRAIL: 'Return to trail',
      THANKS_FOR_CONTRIBUTING: 'Thanks for contributing!',
      YOUR_CHANGES: "Your Changes will be reviewed and the trail updated as soon as they're approved.",
      CONTRIBUTE_HELP: 'Contribute Help',
      LAST_EDITED: 'Last edited',
      PLEASE_ENTER_TRAIL_NAME: 'Please enter a trail name.',
      PLEASE_ENTER_CITY: 'Please choose or enter a city.',
      PLEASE_ENTER_CITY_NAME: 'Please enter a city name.',
      PLEASE_CHOOSE_COUNTRY: 'Please choose a country.',
      PLEASE_DRAW_TRAIL: 'Please draw the route of the trail.',
      TRAIL_TOO_SHORT: 'The trail must be at least {minimumLength} long and is currently only {currentLength}.',
      PLEASE_SELECT_ACTIVITY: 'Please select at least one activity for the trail.',
      PLEASE_FIX_POINT_TO_POINT:
        'The start & end of the route are at the same location even though the route type is set to Point-to-Point. Please fix the route or correct the route type before proceeding. If you’re sure this is correct press OK.',
      PLEASE_FIX_TRAIL_END: "The start & end of the trail aren't at the same location. Please finish drawing the route back to the starting point."
    },
    LIFELINE: {
      TRACK_PROGRESS: 'Track Progress',
      VIEW_ROUTE: 'View Planned Route',
      LIVE_UPDATES: 'See Live Updates',
      SEE_COMPLETED: 'See Completed Activity',
      COMPLETED_DATA: 'Completed Activity Details',
      PLANNED_DETAILS: 'Planned Activity Details',
      KEEP_ADVENTURERS_SAFE: 'Keeping adventurers safe on the trail',
      SMS_RATES: 'Standard SMS rates will apply to messages you receive.  Live tracking can only update when the user’s phone has a data signal.',
      MORE_INFO: 'More Info',
      NOT_STARTED_YET: 'Not Started Yet or No Data Signal',
      FINISHED_AND_SAFE: 'Finished & Reported Safe',
      ACTIVITY_IN_PROGRESS: 'Activity In Progress',
      DIRECTIONS_TRAILHEAD: 'Directions to Trailhead',
      LAST_RECORDED: 'LAST RECORDED TIME',
      LAST_RECORDED_LOC: 'LAST RECORDED LOCATION',
      ACTUAL_START: 'ACTUAL START TIME',
      PLANNED_START: 'PLANNED START TIME',
      PLANNED_END: 'PLANNED END TIME',
      ACTUAL_DISTANCE: 'ACTUAL DISTANCE',
      PLANNED_DISTANCE: 'PLANNED DISTANCE',
      ACTUAL_ELEV: 'ACTUAL ELEVATION GAIN',
      PLANNED_ELEV: 'PLANNED ELEVATION GAIN',
      NOT_STARTED: 'Not Started',
      NO_DATA_RECEIVED: 'No Data Received',
      GET_DETAILS: 'Get the details before they hit the trail. See planned start and end times for their upcoming adventure.',
      STAY_INFORMED: 'Stay informed and track progress. Follow where they are on an easy-to-read map.',
      SEE_STATS: 'See stats like total distance and elevation gain to track their accomplishments.',
      STAY_IN_CONTACT: "Stay in contact. We’ll notify you once they're back safely or if they're running late.",
      OVERDUE: 'Overdue',
      SCHEDULED_END: 'Scheduled end time:',
      SCHEDULED_START: 'Scheduled start time:',
      SHARED_MSG:
        "Has shared a Lifeline with you.  You can follow {userFirstName}'s real-time location during the activity.  If you or {userFirstName} encounter limited GPS or data coverage, Lifeline information could be delayed.",
      LATE_START:
        '{userFirstName} planned to start this activity by now, but either doesn’t have a data connection, or isn’t navigating in the AllTrails app yet. Please check back in a bit.',
      DO_NOT_PANIC: 'Do not panic',
      EMERGENCY: 'Emergency Services',
      REASSURANCE_MSG:
        "It is likely {userFirstName} is alright. {userFirstName}'s phone may have lost connection, battery power, or {userFirstName} is running behind and still enjoying the trail.",
      PROVIDE_INFO:
        'If you have reason to believe {userFirstName} is in danger, contact local authorities associated with the trail.  Please provide the trail information below to local emergency services.'
    },
    OVERLAYS: {
      WEATHER: 'Weather',
      AIR_QUALITY: 'Air quality',
      POLLEN: 'Pollen',
      LIGHT: 'Light pollution',
      FIRE_HISTORY: 'Fire history',
      NEARBY_TRAILS: 'Nearby trails',
      HEATMAP: 'Heatmap',
      PHOTOS: 'Photos',
      WAYPOINTS: 'Waypoints',
      US_CONTOURS: 'US contours',
      WAYMARKED_HIKING: 'Waymarked hiking',
      WAYMARKED_CYCLING: 'Waymarked cycling',
      WAYMARKED_MTB: 'Waymarked MTB',
      DISTANCE_MARKERS: 'Distance markers'
    },
    PROGRESS_MESSAGES: {
      PROCESSING: 'Processing',
      SAVED: 'Saved',
      LOADED: 'Loaded',
      ERROR_SAVING: 'Error saving, please try again.'
    },
    FILTERS: {
      MORE_FILTERS: 'More filters',
      TRAIL_LINKED: 'Linked to trail',
      TRAIL_UNLINKED: 'Not linked to trail',
      TRAIL_COMPLETION: 'Trail completion',
      DIFFICULTY: 'Difficulty',
      ACTIVITY: 'What to do',
      ACTIVITY_LABEL: 'Activity',
      FEATURES: 'What to see',
      FEATURES_LABEL: 'Attractions',
      SUITABILITY: 'Suitability',
      PARK: 'Park',
      CITY: 'City',
      STATE: 'State',
      COUNTRY: 'Country',
      ELEV_GAIN: 'Elevation gain',
      LENGTH: 'Length',
      TIME: 'Time',
      EST: 'Est.',
      ROUTE_TYPE: 'Route type',
      TRAIL_TRAFFIC: 'Trail traffic',
      RATING: 'Rating',
      SORT: 'Sort by',
      SORT_LABEL: 'Sort',
      DISTANCE_AWAY: 'Distance away',
      AND_UP: '& up',
      ACTIVITIES: {
        BACKPACKING: 'Backpacking',
        BIKE_TOURING: 'Bike touring',
        BIRDING: 'Bird watching',
        CAMPING: 'Camping',
        CROSS_COUNTRY_SKIING: 'Cross-country skiing',
        FISHING: 'Fishing',
        HIKING: 'Hiking',
        HORSEBACK_RIDING: 'Horseback riding',
        MOUNTAIN_BIKING: 'Mountain biking',
        OFF_ROAD_DRIVING: 'OHV/Off-road driving',
        PADDLE_SPORTS: 'Paddle sports',
        ROAD_BIKING: 'Road biking',
        ROCK_CLIMBING: 'Rock climbing',
        SCENIC_DRIVING: 'Scenic driving',
        SKIING: 'Skiing',
        SNOWSHOEING: 'Snowshoeing',
        SURFING: 'Surfing',
        TRAIL_RUNNING: 'Running',
        RUNNING: 'Running',
        VIA_FERRATA: 'Via ferrata',
        WALKING: 'Walking',
        BIRD_WATCHING: 'Bird watching'
      },
      FEATURE_TYPES: {
        BEACH: 'Beach',
        CAVE: 'Cave',
        CITY_WALK: 'City walk',
        EVENT: 'Event',
        FOREST: 'Forest',
        HISTORIC_SITE: 'Historic site',
        HOT_SPRINGS: 'Hot springs',
        LAKE: 'Lake',
        PUB_WALK: 'Pub walk',
        PUB_CRAWL: 'Pub walk',
        RAILS_TRAILS: 'Rails trails',
        RIVER: 'River',
        VIEWS: 'Views',
        WATERFALL: 'Waterfall',
        WILD_FLOWERS: 'Wildflowers',
        WILDLIFE: 'Wildlife'
      },
      OBSTACLES: {
        BLOWDOWN: 'Blowdown',
        BRIDGE_OUT: 'Bridge out',
        BUGS: 'Bugs',
        CLOSED: 'Closed',
        FEE: 'Fee',
        FLOODED: 'Flooded',
        GREAT: 'Great!',
        ICY: 'Icy',
        MUDDY: 'Muddy',
        NO_SHADE: 'No shade',
        OFF_TRAIL: 'Off trail',
        OVER_GROWN: 'Over grown',
        PRIVATE_PROPERTY: 'Private property',
        ROCKY: 'Rocky',
        SCRAMBLE: 'Scramble',
        SNOW: 'Snow',
        WASHED_OUT: 'Washed out'
      },
      ACCESS: {
        ADA: 'Wheelchair friendly',
        DOGS: 'Dog friendly',
        DOGS_LEASH: 'Dogs on leash',
        DOGS_ON_LEASH: 'Dogs on leash',
        KIDS: 'Kid friendly',
        KID_FRIENDLY: 'Kid friendly',
        NO_DOGS: 'No dogs',
        DOGS_NO: 'No dogs',
        PARTIALLY_PAVED: 'Partially paved',
        PAVED: 'Paved',
        STROLLERS: 'Stroller friendly'
      },
      ROUTE_TYPES: {
        LOOP: 'Loop',
        OUT_AND_BACK: 'Out & back',
        POINT_TO_POINT: 'Point to point'
      },
      USAGES: {
        LIGHT: 'Light',
        MODERATE: 'Moderate',
        HEAVY: 'Heavy',
        EXTRA_HEAVY: 'Extra heavy'
      },
      SORT_TYPES: {
        BEST_MATCH: 'Best match',
        MOST_POPULAR: 'Most popular',
        NEWLY_ADDED: 'Newly added',
        CLOSEST: 'Closest',
        LIST_ORDER: 'List order',
        DATE: 'Date',
        NAME: 'Name',
        RECENTLY_ADDED: 'Recently added'
      },
      COMPLETED: 'Completed',
      UNCOMPLETED: 'Not completed',
      VERIFIED: 'Verified completed',
      UNVERIFIED: 'Completed',
      OPEN: 'Open'
    },
    MOBILE: {
      TEXT_LINK: 'Text link',
      SENT: 'Sent',
      SENDING: 'Sending',
      ERROR_SEND_TEXT: 'There was a problem sending the text.  Please check the number and try again.'
    },
    DIFFICULTY: {
      CAPS: {
        DEFAULT: 'DIFFICULTY',
        EASY: 'EASY',
        MODERATE: 'MODERATE',
        HARD: 'HARD'
      },
      LOWER: {
        DEFAULT: 'difficulty',
        EASY: 'easy',
        MODERATE: 'moderate',
        HARD: 'hard'
      },
      NORMAL: {
        EASY: 'Easy',
        MODERATE: 'Moderate',
        HARD: 'Hard',
        DIFFICULT: 'Difficult',
        STRENUOUS: 'Strenuous'
      }
    },
    COUPON: {
      FREE: 'free'
    },
    SIGNUP: {
      AT_LEAST_SIX_CHARS: 'Must be at least 6 characters',
      EMAIL: 'Email',
      PASSWORD: 'Password',
      FIRST_NAME: 'First name',
      LAST_NAME: 'Last name',
      LOGIN: 'Log in',
      CONNECT_WITH_GOOGLE: 'Connect with Google',
      CONNECT_WITH_APPLE: 'Connect with Apple',
      CONNECTED: 'Connected',
      UNLINK: 'unlink',
      SIGNUP: 'Sign up'
    },
    PRO: {
      ALLTRAILS_PRO: 'AllTrails Pro',
      REDEEM: 'Redeem',
      PURCHASE: 'Purchase',
      LIFETIME: 'Lifetime',
      ANNUAL: 'Annual',
      MONTH: 'Month',
      YEAR: 'Year',
      THREE_YEAR: '3 Year',
      ZIPCODE: 'Zipcode'
    },
    CONVERTER: {
      FILE_TYPES: {
        ROUTE: 'Track / Route',
        WAYPOINTS: 'Waypoints'
      },
      ERROR_MESSAGES: {
        NO_FILE_ATTACHED: 'Please attach a file or file url to convert.',
        TOO_LARGE: 'Your file is too large, Please choose a file below 8mb.',
        UPLOAD_FAILED: 'There was an issue uploading your file. Please check your file and try again.'
      },
      ROUTE_OPTION_STRINGS: {
        REVERSE_ROUTE: 'Reverse route',
        OUT_AND_BACK: 'Change to Out & Back route',
        ADD_ELEVATION: 'Add / Replace elevation',
        COMBINE_ROUTES: 'Combine multiple routes into one route'
      },
      ROUTE_SIMPLIFICATION_STRINGS: {
        NONE: 'None',
        LOW: 'Low (Reduce by 25%)',
        MEDIUM: 'Medium (Reduce by 50%)',
        HIGH: 'High (Reduce by 75%)',
        CUSTOM: 'Customize:'
      },
      ON: 'On',
      OFF: 'Off',
      OR: 'or',
      HERO_TITLE: 'Route Converter',
      UPLOAD_FILE: 'Upload File',
      UPLOAD_FILE_PROMPT: 'Use the AllTrails Route Converter to upload a route and convert to any of our supported file formats.',
      DRAG_PROMPT: 'Drag supported file here',
      DRAG_PROMPT_LINK: 'Or choose file to upload',
      FILE_URL_PLACEHOLDER: 'Link to supported file here',
      CONVERT_TO: 'Convert to',
      DOWNLOAD_AS: 'Download as:',
      CUSTOMIZE_ROUTE: 'Customize Route',
      ROUTE_OPTIONS: 'Route Options',
      ROUTE_SIMPLIFICATION: 'Route Simplification',
      CUE_SHEETS: 'Cue Sheets',
      CUE_SHEETS_PROMPT: 'Cue sheets can be used with third party vendors. You can customize cues to meet the specifications of your watch or device',
      NUMBER_OF_CUES: 'Number of cues:',
      MOVE_CUE_LEAD: 'Move cue:',
      MOVE_CUE_TAIL: 'before turn',
      CONVERT_BUTTON: 'Convert file',
      SUBMITTING_TEXT: 'Please wait',
      DRAG_SUPPORTED: 'Drag supported file here',
      OR_CHOOSE_FILE: 'Or choose file to upload',
      FILE_SIZE: 'File Size',
      REMOVE_FILE: 'Remove file',
      SUPPORTED_FORMATS_LEAD: 'The following formats are supported (maximum 8MB, automatically detected):',
      CONVERT_FILE: 'Convert file',
      CONVERTER_SUCCESS: {
        TITLE: 'All finished!',
        SUBMITTING_TEXT: 'Please wait',
        PROMPT_LEAD: 'Your new file was added to your “downloads” folder. If you do not see the file, click',
        HERE: 'here',
        PROMPT_TAIL: 'to retry your download. Have fun out on the trail!',
        CONVERT_ANOTHER_FILE: 'Convert another file',
        SUBTITLE_SAVE: 'Save this route to your account and never lose the file',
        BUTTON_SAVE: 'Save to',
        RECORDINGS: 'Activities',
        MAPS: 'Maps',
        SUBTITLE_CREATE_MAP: 'Create custom maps to personalize your trip',
        BUTTON_CREATE_MAP: 'Create New Map'
      }
    },
    COMMUNITY: {
      COMMUNITY: 'Community',
      EMPTY_STATES: {
        RETRY: 'Retry'
      },
      CONTACTS: 'Contacts',
      CONNECT: {
        CONNECT: 'Connect',
        VIEW_ALL: 'View all',
        FOLLOWER_REQUESTS: 'Follower requests'
      },
      BELAY_CONNECTIONS: {
        BLOCKING: 'Blocking',
        UNBLOCKING: 'Unblocking'
      }
    },
    EMPTY_STATES: {
      FAVORITES: {
        KEEP_TRACK: 'Keep track of the ones you love',
        TAP_THE_HEART_ICON: 'Tap the save icon on any trail, map, or activity to start saving your favorites here.',
        START_EXPLORING: 'Start exploring'
      },
      MAPS: {
        PLAN_YOUR_PERFECT_ROUTE: 'Plan your perfect route',
        MAP_CREATOR_TOOL: 'Use the AllTrails map creator tool for a custom route or download and save curated maps.',
        CREATE_MAP: 'Create map'
      },
      ACTIVITIES: {
        KEEP_TRACK_ACTIVITIES: 'Keep track of your activities',
        SAVE_ACTIVITIES:
          'Save activities by navigating your route in the AllTrails app. On desktop, upload activities from Garmin, Google, and more.',
        UPLOAD_FILE: 'Upload file'
      },
      COMPLETED: {
        COMPLETE_TRAILS: 'Let’s complete some trails',
        COMPLETED_TAB_LIST: 'Add to this list from the Completed tab of any trail. Or download the AllTrails app to save new travels with Navigator.'
      },
      CUSTOM: {
        BUILD_PERSONAL_LIST: 'Build your personal lists',
        PERSONAL_LIST_SUBTEXT: 'Tap the save icon on any trail, map or recording to start saving your personal favorites here.'
      }
    },
    NAVIGATION: {
      PRO_BADGE_ALT_TEXT: 'Learn more about pro subscription',
      LOGIN: 'Log In',
      SIGNUP: 'Sign Up',
      LOGOUT: 'Logout',
      SETTINGS: 'Settings',
      MEMBERS: 'Members',
      PHOTOS: 'Photos',
      REVIEWS: 'Reviews',
      PROFILE: 'Profile',
      ACTIVITIES: 'Activities',
      COMMUNITY: 'Community',
      EXPLORE: 'Explore',
      PLAN: 'Plan',
      MY_FAVORITES: 'My favorites',
      LISTS: 'Lists',
      MY_MAPS: 'My maps',
      CREATE_MAP: 'Create Map',
      HISTORY: 'History',
      RECORDINGS: 'Activities',
      COMPLETED: 'Completed',
      STATS: 'Stats',
      HELP: 'Help',
      SAVED: 'Saved'
    },
    NAVIGATOR_MODAL: {
      HEAD_TO_THE: 'Head to the AllTrails app on your iOS or Android phone to begin navigating.', // Alternate sub-heading for non-english languages
      ANY_NUMBER:
        'Please note: Any number you enter here is just for you. We won’t save your information or contact you without permission. Texting is only available for United States mobile numbers.'
    },
    SHARE_MODAL: {
      COPY_NOT_AVAILABLE: 'Copy Link is not available in your web browser',
      ON_ALLTRAILS: 'on AllTrails',
      CHECK_THIS_OUT_ON_ALLTRAILS: 'Check this out on AllTrails',
      DOWNLOAD_THE_FREE_ALLTRAILS_APP: 'Download the free AllTrails App.',
      // "Embed/Text this..." strings are not referenced directly but used in share_modal
      EMBED_THIS_TRAIL: 'Embed this trail',
      TEXT_THIS_TRAIL: 'Text this trail',
      EMBED_THIS_MAP: 'Embed this map',
      TEXT_THIS_MAP: 'Text this map',
      EMBED_THIS_TRACK: 'Embed this activity',
      TEXT_THIS_TRACK: 'Text this activity',
      EMBED_THIS_LIST: 'Embed this list',
      TEXT_THIS_LIST: 'Text this list',
      EMBED_THIS_AREA: 'Embed this park',
      TEXT_THIS_AREA: 'Text this park',
      EMBED_THIS_STATE: 'Embed this state',
      TEXT_THIS_STATE: 'Text this state',
      EMBED_THIS_COUNTRY: 'Embed this country',
      TEXT_THIS_COUNTRY: 'Text this country',
      EMBED_THIS_CITY: 'Embed this city',
      TEXT_THIS_CITY: 'Text this city',
      COPY_LINK: 'Copy Link',
      LINK_COPIED: 'Link Copied',
      SEND_TEXT: 'Text',
      TEXT_SENT: 'Text Sent',
      SEND_EMAIL: 'Email',
      EMBED_WIDGET: 'Embed',
      QR_CODE: 'QR Code',
      TO_ADD_THIS_TRAIL_TO_YOUR_WEBSITE: 'To add this trail to your website, copy and paste the following HTML into your website code:',
      CUSTOMIZE_YOUR_CODE: 'Customize your code',
      COPY_HTML: 'Copy HTML',
      HTML_COPIED: 'HTML Copied',
      DEACTIVATE_MOUSE_ZOOM: 'Deactivate zoom with mouse',
      HIDE_ELEVATION_GRAPH: 'Hide elevation graph',
      HIDE_YOUR_NAME: 'Hide your name',
      PREVIEW: 'Preview',
      DOWNLOAD_QR_CODE: 'Download QR Code',
      DOWNLOAD_INSTRUCTIONS:
        'Download this QR Code to quickly link others to the important information on this page. QR codes can be read by any device with the appropriate software. Use the smart phone or tablet to read the QR code.',
      SMS_INSTRUCTIONS:
        'Text this trail to your friends, family or yourself so you can get driving directions and see detailed trail maps on the go.',
      PRIVATE_WARNING: 'This content is private and only you will be able to view it.'
    },
    LIST_MODAL: {
      CREATE_A_LIST: 'Create a list',
      NAME_YOUR_LIST: 'Name your list'
    },
    MAP_CREATOR: {
      ACTIVITY: 'Activity',
      ADD_AS_NEW_MAP: 'Add as new map',
      ADD_NEW_PHOTOS: 'Add new photos',
      ADD_TO_ROUTE: 'Add to route',
      CLICK_TO_ADD_POINT: 'Click to add point',
      CLOSE_POPUP: 'Close popup',
      CREATE_A_CUSTOM_MAP: 'Create a custom map',
      DESCRIPTION_LABEL: 'Add notes about your route',
      DESCRIPTION: 'Description',
      DRAG_TO_CHANGE_DELETE_TO_REMOVE: "Drag to change route, 'delete' to remove",
      DRAW_ON_MAP: 'Draw on map',
      EASILY_PLAN_THE_PERFECT_PATH: 'Easily plan the perfect path for your next hike, bike, or run with our Map Creator tool.',
      EDIT_MAP: 'Edit map',
      ERROR_SAVING: 'Error saving',
      LINKED_TRAIL: 'Linked trail',
      NEW_MAP_CREATED: 'New map created',
      PHOTOS: 'Photos',
      PRIVATE: 'Make map private',
      SAVE_CUSTOM_MAP: 'Save custom map',
      SEARCH_FOR_LOCATION: 'Search for a location or click anywhere on the map to draw',
      SEARCH_OR_CLICK_ON_MAP_TO_START: 'Search or click on the map to start',
      START_HERE: 'Start here',
      SUGGEST_AS_NEW_TRAIL: 'Suggest as new trail',
      TITLE_LABEL: 'Name your map',
      UPLOAD_FROM_FILE: 'Upload from file',
      WAYPOINT_ERROR: 'There has been an error, please try again',
      WAYPOINTS: 'Waypoints',
      YOUR_ROUTE: 'Your route',
      ROUTE_WITH_NUMBER: number => `Route ${number}`
    },
    REDEMPTION_PAGE: {
      REDEEM: 'Redeem',
      REDEMPTION_CODE: 'Redemption Code',
      ONCE_YOU_REDEEM: `Once you redeem the gift subscription, your account will be updated and you can start enjoying the benefits of Pro. Your subscription begins on the redemption date and will be active for the length of the plan that was purchased.`,
      MOBILE_GIFT: {
        __html: `Your account has a current mobile subscription. Please read our <a href="https://support.alltrails.com/hc/en/articles/360052407531-I-already-have-a-Pro-subscription-through-iTunes-or-Google-Play-how-can-I-redeem-the-gift-I-received-" target="_blank">FAQ</a> to learn how to redeem your gift.`
      }
    },
    ALLTRAILS_GIFT_SUBSCRIPTION: 'AllTrails gift subscription',
    GIFT_FLOW: {
      GIVE_THE_GIFT: 'Give the gift of adventure',
      FEATURES_DESIGNED_FOR_ALL: 'Features designed for all',
      BUY_GIFT: 'Buy gift',
      AN_EASY_WAY: 'An easy way to give joy',
      SEND_THE_GIFT_OF_EXPLORATION: 'Send the gift of exploration to your friends and family with an AllTrails Pro gift subscription.',
      QUICK_AND_EASY: 'Quick and easy',
      PURCHASE_EASILY: 'Purchase a gift subscription easily. It arrives in moments and we notify you of delivery.',
      CUSTOMIZABLE: 'Customizable',
      CHOOSE_LENGTH_OF_PLAN: 'Choose the length of plan, a design you love and personalize a message.',
      SEND_VIA_EMAIL_PRINT: 'Send via email or print',
      CHOOSE_DELIVERY_DATE: 'Choose the delivery date the gift subscription will be emailed. Or, print and hand-deliver.',
      PERFECT_FOR_ALL_OCCASIONS: 'Perfect for all occasions and outdoor enthusiasts.',
      CELEBRATE_THE_PEOPLE:
        'Celebrate the people you appreciate on birthdays, holidays, graduations and more. With the ability to browse by activity, it’s a fitting gift for any type of outdoor explorer in your life.',
      GIVE_A_GIFT_CARD: 'Give an AllTrails Pro gift subscription',
      HELP_GET_ADVENTURE_STARTED: 'Help them get the adventure started.',
      CHOOSE_A_CHECKOUT_METHOD: 'Choose a checkout method',
      CHECKOUT_AS_GUEST: 'Checkout as guest',
      ALT_TEXT: {
        FRIENDS_AT_THE_SUMMIT: 'Friends relaxing at a rocky summit',
        TWO_CYCLISTS: 'Two cyclists walking their bikes across a wooden bridge',
        PERSON_TRAIL_RUNNING: 'Person trail running on a beautiful sunny day',
        PERSON_CYCLING: 'Person cycling up a long and windy hill'
      },
      GIFT_REVIEW: {
        PLEASE_CONFIRM_RECIPIENT_DETAILS: 'Please confirm recipient details'
      },
      FAQ: {
        HOW_DO_I_REDEEM: 'How do I redeem my subscription?',
        HOW_DO_I_REDEEM_ANSWER:
          'AllTrails gift subscriptions are delivered by email. They contain a redemption code and link to redeem on the web. When redeemed, the Pro subscription will be applied to your account.',
        CAN_I_GIVE_A_SUBSCRIPTION: 'Can I give a subscription to someone who already has a Pro account?',
        CAN_I_GIVE_A_SUBSCRIPTION_ANSWER:
          "Yes! If your recipient has a subscription directly with AllTrails, they can redeem your gift now and it will be applied at their next renewal. If their current subscription is through Google Play or the Apple App Store, they'll need to let it expire or cancel before redeeming (unfortunately, gift subscriptions don’t work in the app stores). Luckily, they have 24 months to use the gift subscription before it expires.",
        WILL_I_KNOW: 'Will I know if my recipient receives their gift?',
        WILL_I_KNOW_ANSWER: "Absolutely. We'll send you an email notification as soon as the gift email is opened.",
        WAS_NOT_RECIEVED: 'The subscription I sent wasn’t received?',
        WAS_NOT_RECIEVED_ANSWER:
          'We can help! Please send your order confirmation number to <a>support@alltrails.com</a> and our customer support team will get to the bottom of it.',
        IS_THERE_AN_EXPIRATION: 'Is there an expiration date on the subscription?',
        IS_THERE_AN_EXPIRATION_ANSWER:
          'Yes, your recipient will have 24 months to redeem their subscription from the moment they receive the gift. Once redeemed, the code is good for the length of the subscription that was gifted. For example, if you gift someone a year subscription, that year begins whenever they redeem it.',
        CAN_I_BUY_A_PHYSICAL_GIFT_CARD: 'Can I buy a physical gift subscription?',
        CAN_I_BUY_A_PHYSICAL_GIFT_CARD_ANSWER:
          "If you don't want your gift delivered by email, you'll have the option to print instead. Then you can deliver your gift by hand or by mail and the PDF will include all the information your recipient needs to redeem it.",
        FREQUENTLY_ASKED_QUESTIONS: 'Frequently asked questions'
      },
      GIFT_CUSTOMIZE_FORM: {
        EMAIL: 'Email',
        PRINT: 'Print',
        ENTER_AN_EMAIL: 'Enter an email',
        ENTER_A_NAME: 'Enter a name',
        ENTER_VALID_EMAIL: 'Enter a valid email',
        CUSTOMIZE_YOUR_GIFT: 'Customize your gift',
        HOW_DO_YOU_WANT_TO_SEND: 'How do you want to send it?',
        TO: 'To',
        FROM: 'From',
        NAME: 'Name',
        MESSAGE: 'Message',
        SEND_DATE: 'Send date',
        NEXT: 'Next',
        FIVE_HUNDRED_CHARACTERS_MAX: '500 character maximum',
        SEND_TODAY: 'Send today',
        SEND_AT_A_LATER_DATE: 'Send at a later date'
      },
      PRINT: {
        NEW_TO_ALLTRAILS: 'New to AllTrails?',
        ALREADY_HAVE_ONE: 'Already have an AllTrails account?',
        REDEMPTION_CODE: 'Redemption code',
        YOUR_GIFT_SUBSCRIPTION: 'Your gift subscription',
        ANNUAL_PRO_PLAN: 'Annual Pro Plan',
        THREE_YEAR_PRO_PLAN: 'Three-Year Pro Plan'
      },
      PAYMENT_FORM: {
        SUBMIT_TEXT: 'Give AllTrails Pro'
      },
      ATHLETES: {
        HIKERS: 'Hikers',
        MOUNTAIN_BIKERS: 'Mountain bikers',
        TRAIL_RUNNERS: 'Trail runners',
        BACKPACKERS: 'Backpackers',
        ROAD_BIKERS: 'Road bikers',
        ROCK_CLIMBERS: 'Rock climbers',
        SNOWSHOERS: 'Snowshoers',
        SKIERS: 'Skiers'
      },
      AND_MORE: 'and more'
    },
    PRINT_PAGE: {
      PRINT_MAP: 'Print map', // Lower case m for the title
      PRINT_YOUR_OWN: 'Print your own customizable maps for backup.',
      PAPER_SIZE: 'Paper size',
      ORIENTATION: 'Orientation',
      GRID: 'Grid',
      SCALE: 'Scale',
      DOWNLOAD_PDF: 'Download PDF',
      PRINT_MAP_BUTTON: 'Print Map', // Capital M for the button
      LEARN_MORE: 'Learn more',
      PAPER_LETTER_IMPERIAL: 'Letter',
      PAPER_LETTER_METRIC: 'A4',
      PAPER_LETTER_DIMENSIONS_IMPERIAL: '8.5” x 11”',
      PAPER_LETTER_DIMENSIONS_METRICS: '21.0 x 29.7 cm',
      PAPER_LEGAL_IMPERIAL: 'Legal',
      PAPER_LEGAL_METRIC: 'A3',
      PAPER_LEGAL_DIMENSIONS_IMPERIAL: '8.5” x 14”',
      PAPER_LEGAL_DIMENSIONS_METRICS: '42.0 x 29.7 cm',
      PAPER_TABLOID_IMPERIAL: 'Tabloid',
      PAPER_TABLOID_METRIC: 'A2',
      PAPER_TABLOID_DIMENSIONS_IMPERIAL: '11” x 17”',
      PAPER_TABLOID_DIMENSIONS_METRICS: '59.4 x 42.0 cm',
      PAPER_CUSTOM: 'Custom',
      PAPER_CUSTOM_DIMENSIONS: 'Any size',
      LAYOUT: 'Layout',
      ORIENTATION_PORTRAIT: 'Portrait',
      ORIENTATION_VERTICAL: 'Vertical',
      ORIENTATION_LANDSCAPE: 'Landscape',
      ORIENTATION_HORIZONTAL: 'Horizontal',
      GRID_DECIMAL: 'Decimal',
      MILES: 'MILES',
      METERS: 'METERS',
      PRINT_SETTINGS: 'Print settings',
      CREATE_CUSTOM_MAP: 'Create custom map',
      GAIN: 'Gain',
      LOSS: 'Loss',
      NONE_OPTION: 'None',
      EXACT: 'Exact'
    },
    TAKE_YOUR_ALLTRAILS: 'Take your AllTrails experience on the go',
    TRY_THE_ALLTRAILS_APP: 'Try the AllTrails app for your iOS or Android phone. Enter your US mobile number to text yourself a link.',
    GET_MORE_FROM: 'Get more from AllTrails when you download the app on your iOS or Android phone.',
    SEND_LINK: 'Send link',
    DOWNLOAD_THE_APP: 'Download the app',
    THERE_WAS_A_PROBLEM_SENDING_THE_TEXT: 'There was a problem sending the text.',
    PLEASE_CHECK_THE_NUMBER_AND_TRY_AGAIN: 'Please check the number and try again.',
    INVITED_YOU: '{firstName} invited you to hit the trails!',
    DOWNLOAD_THE_FREE_APP: 'Download the free app',
    TWO_PEOPLE_FACING:
      'Two people facing away with brown backpacks on, with one person wearing a maroon hat. They are looking over a landscape of rolling green hills. ',
    PHONE_DOWNLOAD_ICON: 'phone download icon',
    JUST_ONE_MORE_STEP: 'Just one more step',
    THANKS_FOR_PROVIDING_YOUR_EMAIL:
      "Thanks for providing your email. Now, just download the app - and we'll plant one tree for you and one for your friend.",
    SEND_A_LINK_TO_MY_PHONE: 'Send a link to my phone',
    A_CLOSE_UP_OF_TWO:
      "A close-up of two people's hands planting a redwood tree together. One is holding a tree in a black pot, while the other makes room for the tree to be planted in the ground among green redwood needles.",
    HEART_ICON: 'heart icon',
    HEADS_UP_THIS_OFFER_IS_FOR_NEW_MEMBERS_ONLY: 'Heads up: This offer is for new members only.',
    TERMS_AND_CONDITIONS: 'Terms and conditions',
    ONCE_YOU_SIGN_UP:
      "Once you sign up and download the app, we'll plant a tree for each of you. That means you'll be supporting One Tree Planted to restore damage from wildfires and deforestation worldwide.",
    A_PERSON_WTIH_LONG_BROWN_HAIR_IS_WEARING_ORANGE_PANTS:
      'A person with long brown hair is wearing orange pants, a red long sleeve shirt, and a grey beanie while standing on a brown rock with their hands in their pockets. There is brown grass in the foreground and they are looking out over an ocean and beach with blue sky in the background.',
    TWO_PEOPLE_ARE:
      'Two people are walking on a dirt single-track trail on top of a gentle green hill towards a coastline with churning white waves and blue sky. The trail appears to end at an overlook with a view to the left of a beach and dirt cliffs with green trees.',
    A_SMILING_PERSON:
      'A smiling person with long brown hair is wearing brown pants and a plaid blue and maroon shirt. They are balancing on one foot on a log in a lake. There is a mountain covered with snow and some green trees in the background that is reflected in the clear lake water. The sun is shining in the blue sky. ',
    A_PERSON_WTIH_LONG_BROWN_HAIR_IS_WEARING_A_BLACK_HAT:
      'A person with long brown hair is wearing a black hat, red puffer jacket, and black pants with an orange and black backpack. They are standing on green grass with small yellow flowers looking over a coastline of green cliffs, black sand, blue water, and blue sky.',
    ALLTRAILS: 'AllTrails',
    START_EXPLORING_WITH_PRO: 'Start Exploring with Pro',
    FOR_THE_BEST_EXPERIENCE: 'For the best experience, download the AllTrails app or visit alltrails.com on a desktop computer.',
    YOU_RE_AN_OFFICIAL_PRO_SUBSCRIBER: "You're an official Pro subscriber.",
    WELCOME_TO_OUR_COMMUNITY_OF_OUTDOOR_ENTHUSIASTS_JUST_LIKE_YOU: 'Welcome to our community of outdoor enthusiasts just like you.',
    GET_STARTED: 'Get Started',
    UPGRADE_TO_PRO: 'Upgrade to Pro',
    END_TRANSLATE: 'END_TRANSLATE'
  },
  constants: {
    XLATE: {
      GOOGLE: 'xlate-google',
      SMARTLING: 'xlate-smartling',
      NONE: 'xlate-none'
    },
    ALGOLIA: {
      ACCOUNT: '9IOACG5NHE',
      API_KEY: '63a3cf94e0042b9c67abf0892fc1d223',
      INDEX: 'alltrails_index3',
      INDEX_ALPHA: 'alltrails_index3_alpha',
      PENDING_INDEX: 'pending_trails_prod'
    },
    APPLE_SIWA: {
      AUTHORIZE_URL: 'https://appleid.apple.com/auth/authorize',
      AUTHORIZE_PARAMS: '?response_type=code%20id_token&response_mode=form_post',
      CLIENT_ID: 'com.alltrails.AllTrails.web',
      SCOPES: 'name email',
      REDIRECT_PATH: '/users/auth/apple/callback'
    },
    MAGIC: {
      // Same as server-side constant:
      CENTER_LOWER_48: [39.8282102, -98.581832]
    }
  },
  // returns value or original string if not found in supplied dictionary
  stringsLookup(dict, str) {
    if (!str) {
      console.error('Provided null `str` value lookup');
      return '';
    }
    const key = str.toUpperCase().replace(/ /g, '_');
    return dict[key] || str;
  }
};

const replaceStrings = (string, replaceMap) => {
  let newString = string;
  if (replaceMap instanceof Array) {
    for (let i = 0; i < replaceMap.length; i++) {
      const stringKey = `{${replaceMap[i].stringKey}}`;
      newString = newString.replace(stringKey, replaceMap[i].stringValue);
    }
  } else {
    newString = newString.replace(replaceMap.stringKey, replaceMap.stringValue);
  }
  return newString;
};

const ProPageStrings = {
  START_TRANSLATE: 'START_TRANSLATE',
  headText: 'Make the most of the outdoors with Pro',
  featuresList: [
    'Download maps to stay on track without service',
    'Never miss a turn with off-route notifications',
    'Keep friends and family informed with Lifeline',
    'See air quality, pollen, & weather details on any map',
    'Bring trails to life with 3D maps'
  ],
  loginText: {
    headText: "Log in and let's get going",
    stepText: 'Step 2 of 3'
  },
  loginForm: {
    email: {
      title: 'Email',
      validation: {
        generic: 'Email is not valid.'
      }
    },
    firstName: {
      title: 'First name',
      validation: {
        generic: 'Enter your first name.'
      }
    },
    lastName: {
      title: 'Last name',
      validation: {
        generic: 'Enter your last name.'
      }
    },
    password: {
      title: 'Password',
      validation: {
        generic: 'Password must be 6 characters long.'
      }
    }
  },
  END_TRANSLATE: 'END_TRANSLATE'
};

export { StringConstantsMixin, ProPageStrings, replaceStrings };
